import { EmeshApiClient } from "../client";
import {
  AccessToken,
  AccessTokenError
} from "@/typescript/api_client/emesh_api/login/types";
import { AxiosResponse } from "axios";
const emeshApiClient: EmeshApiClient = new EmeshApiClient("/token");

export async function postTokenApi(
  userName: string,
  password: string
): Promise<AccessToken> {
  const params = new URLSearchParams();

  params.append("grant_type", "password");
  params.append("username", userName);
  params.append("password", password);

  return await emeshApiClient
    .post(
      {
        headers: {
          "Content-Type": "x-www-form-urlencoded"
        }
      },
      params
    )
    .then((resp: AxiosResponse<AccessToken>) => {
      return Promise.resolve(resp.data as AccessToken);
    })
    .catch(e => {
      if (e.data) return Promise.reject(e.data as AccessTokenError);
      return Promise.reject(e);
    });
}
